import {lazy} from '@aboutyou/lazy-imports';

export const DiscountBanner = lazy(() =>
  import('./DiscountBanner.eager').then(module => ({
    default: module.DiscountBanner,
  })),
);
